export default __webpack_public_path__ + "static/media/user.6de64a96.png";